import type { ConfirmationOptions } from "primevue/confirmationoptions";

export function useDeleteConfirm(confirm: {
    require: (option: ConfirmationOptions) => void;
    close: () => void;
}) {
    return () => new Promise((resolve) => {
        confirm.require({
            message: 'Wollen sie den Datensatz wirklich löschen?',
            header: 'Datensatz löschen',
            rejectProps: {
                label: 'Abbrechen',
                severity: 'secondary',
                outlined: true
            },
            acceptProps: {
                label: 'Löschen'
            },
            accept: () => resolve(true),
            reject: () => resolve(false)
        });
    });
}